<template>
    <div class="input-search">
        <input :id="id" type="text" autocomplete="off" :placeholder="placeholder" v-model="searchValue" @keydown="showSugestion = true" @onChange="test()">    
        <div class="options" v-if="showSugestion">
            <li v-for="(value, index) in filterValues" :key="index" @click="selectValue(value)">
                <label :for="value" @click="selectValue(value)">{{value}}</label>
            </li>  
        </div>
    </div>
</template>

<script>
export default {
    props:["placeholder","values","id","name"],
    data () { 
        return {
            searchValue: null,
            showSugestion: true
        }
    },
    methods: {
        selectValue(value){
            this.searchValue = value
            this.showSugestion = false
        },
        //@keydown="searchValue > 1 ? isText = true : isText = false"
    },
    computed:{
        filterValues(){return this.values.filter(value =>{
            if(this.searchValue) return value.toLowerCase().match(this.searchValue.toLowerCase())
        })}
    },        
}
</script>

<style lang="scss">
    .input-search{
        .options{
            max-height: 300px;
            overflow: overlay;
            transition: max-height .3s;  
        }
        li{
            list-style-type: none;
            padding: 10px;
            background-color: #fdfeff;
            border: 1px solid #ccc;
            transition: background-color .1s;
            label{
                &:hover{
                    cursor: pointer;
                }          
            }
            &:hover{
                cursor: pointer;
                background-color: #ececec;
            }            
        }
    }
</style>